var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaboration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.334,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_155_30)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1257 31.5846C35.2257 31.5846 32.2648 32.123 30.0007 33.168C27.7365 32.1071 24.7757 31.5846 22.8757 31.5846C19.4398 31.5846 12.584 33.2946 12.584 36.7305V41.0846H47.4173V36.7305C47.4173 33.2946 40.5615 31.5846 37.1257 31.5846ZM30.7923 38.7096H14.959V36.7305C14.959 35.8755 19.0123 33.9596 22.8757 33.9596C26.739 33.9596 30.7923 35.8755 30.7923 36.7305V38.7096ZM45.0423 38.7096H33.1673V36.7305C33.1673 36.0021 32.8507 35.3688 32.344 34.7988C33.7373 34.3238 35.4473 33.9596 37.1257 33.9596C40.989 33.9596 45.0423 35.8755 45.0423 36.7305V38.7096ZM22.8757 30.0013C25.9315 30.0013 28.4173 27.5155 28.4173 24.4596C28.4173 21.4038 25.9315 18.918 22.8757 18.918C19.8198 18.918 17.334 21.4038 17.334 24.4596C17.334 27.5155 19.8198 30.0013 22.8757 30.0013ZM22.8757 21.293C24.6173 21.293 26.0423 22.718 26.0423 24.4596C26.0423 26.2013 24.6173 27.6263 22.8757 27.6263C21.134 27.6263 19.709 26.2013 19.709 24.4596C19.709 22.718 21.134 21.293 22.8757 21.293ZM37.1257 30.0013C40.1815 30.0013 42.6673 27.5155 42.6673 24.4596C42.6673 21.4038 40.1815 18.918 37.1257 18.918C34.0698 18.918 31.584 21.4038 31.584 24.4596C31.584 27.5155 34.0698 30.0013 37.1257 30.0013ZM37.1257 21.293C38.8673 21.293 40.2923 22.718 40.2923 24.4596C40.2923 26.2013 38.8673 27.6263 37.1257 27.6263C35.384 27.6263 33.959 26.2013 33.959 24.4596C33.959 22.718 35.384 21.293 37.1257 21.293Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_30",
    x1: 30.334,
    y1: 0,
    x2: 30.334,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3896BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "static/media/Collaboration.30177f2d859e36f43fee3c3a2406f341.svg";
export { ForwardRef as ReactComponent };